<template>
  <div class="fund-options">
    <div v-if="!smallLoading" class="fund-options__list">
      <!-- Same options, labels, fees and times as the mobile app -->
      <button
        v-for="option in options"
        :key="option.key"
        class="fund-options__item"
        @click="clicked(option.key)"
      >
        <div class="fund-options__icon">
          <svg v-if="option.icon === 'card'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
            <path d="M2 8H18" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5 12H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <svg v-else-if="option.icon === 'bank'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7L10 3L17 7V9H3V7Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M4 9V14M8 9V14M12 9V14M16 9V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M2 17H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M2 14H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <svg v-else-if="option.icon === 'phone'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="2" width="10" height="16" rx="2" stroke="currentColor" stroke-width="1.5"/>
            <circle cx="10" cy="14" r="1" fill="currentColor"/>
          </svg>
          <svg v-else-if="option.icon === 'p2p'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="3" stroke="currentColor" stroke-width="1.5"/>
            <circle cx="13" cy="13" r="3" stroke="currentColor" stroke-width="1.5"/>
            <path d="M10 4L12 6L10 8M10 12L8 14L10 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M10 5V15M7 7H12M7 13H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="fund-options__content">
          <h4>{{ option.title }}</h4>
          <p>
            {{ option.subtitle }} · Fee: {{ option.fee }}<template v-if="option.duration"> · {{ option.duration }}</template>
          </p>
        </div>
        <svg class="fund-options__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <SmallLoader v-if="smallLoading" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "FundOptionsForm",

  emits: ["options", "open-bvn"],

  props: {},

  data() {
    return {
      fundMethod: "",
    };
  },

  computed: {
    ...mapState({
      organisationDetails: (state) => state.organisationModule.organisationDetails,
      currency: (state) => state.organisationModule.currency,
      smallLoading: (state) => state.smallLoading,
    }),
    bvn() {
      return this.organisationDetails.bvn;
    },
    options() {
      const all = [
        { key: "Fund with debit card", icon: "card", title: "Fund with Flutterwave Card", subtitle: "Debit/credit card payment", fee: "1.5% - 3.8%" },
        { key: "Flutterwave Bank Transfer", icon: "bank", title: "Fund with Flutterwave Bank", subtitle: "Transfer from your bank", fee: "1.5% capped at ₦2,000", currencies: ["NGN"] },
        { key: "Mobile Money", icon: "phone", title: "Fund with Flutterwave M-Pesa", subtitle: "Pay from your M-Pesa wallet", fee: "1.5%", currencies: ["KES"] },
        { key: "P2P Transfers", icon: "p2p", title: "P2P Transfers", subtitle: "Peer-to-peer transfers", fee: "1.5%", duration: "1 hour", currencies: ["USD"] },
        { key: "Crypto", icon: "crypto", title: "Fund with Crypto", subtitle: "Cryptocurrency deposit", fee: "1%", duration: "~5 mins", currencies: ["USD"] },
      ];
      return all.filter((o) => !o.currencies || o.currencies.includes(this.currency));
    },
  },

  methods: {
    ...mapActions(["showToast"]),
    ...mapActions("organisationModule", ["setFundMethod", "getVirtualAccount"]),

    async clicked(options) {
      if (options === "Fund with debit card" || options === "Mobile Money") {
        this.fundMethod = "fiat";
      }
      if (options === "Flutterwave Bank Transfer") {
        this.fundMethod = "flutterwave";
      }
      if (options === "Crypto") {
        this.fundMethod = "crypto";
      }
      if (options === "Bank Transfer") {
        this.fundMethod = "transfer";
      }
      if (options === "Fund with Fintech Apps") {
        this.fundMethod = "fintech";
      }
      if (options === "Another wallet") {
        this.fundMethod = "wallet";
      }
      if (options === "P2P Transfers") {
        this.fundMethod = "p2p";
      }
      if (options === "Bank or Card") {
        this.fundMethod = "bankOrCard";
      }
      if (
        this.fundMethod === "transfer" &&
        this.currency === "NGN" &&
        !this.bvn
      ) {
        this.showToast({
          description: "Please add your BVN to get your virtual account number",
          display: true,
          type: "error",
        });
        this.$emit("open-bvn");
      } else {
        this.setFundMethod(this.fundMethod);
        this.$emit("options", options);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-card: #FFFFFF;
$bg-subtle: #F1F5F9;
$border-color: #E2E8F0;
$accent-primary: #6366F1;
$accent-light: #EEF2FF;

.fund-options {
  padding: 8px 0;

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid $border-color;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: $bg-subtle;
      margin: 0 -16px;
      padding: 16px;
      width: calc(100% + 32px);
      border-radius: 10px;
      border-bottom-color: transparent;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $accent-light;
    border-radius: 10px;
    color: $accent-primary;
    flex-shrink: 0;
  }

  &__content {
    flex: 1;

    h4 {
      font-size: 14px;
      font-weight: 600;
      color: $text-primary;
      margin: 0 0 2px;
    }

    p {
      font-size: 13px;
      color: $text-muted;
      margin: 0;
    }
  }

  &__arrow {
    color: $text-muted;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &__item:hover &__arrow {
    transform: translateX(2px);
  }
}
</style>
